import backend from 'app/backend';
import { dispatch } from 'app/store';
import { LicenseSeat, LicenseSeatActivation } from 'types/license';
export default function BeginDeactivation(beginDeactivationArgs: {
  SeatID: LicenseSeat['ID'];
  MachineID: LicenseSeatActivation['MachineID'];
}) {
  dispatch({
    type: 'BEGIN_DEACTIVATION_START',
  });
  backend
    .dispatch('BeginDeactivation', beginDeactivationArgs)
    .then((response) => {
      if (!response.Success) {
        dispatch({
          type: 'BEGIN_DEACTIVATION_FAIL',
          message: response.Error,
        });
        return;
      }
      const updatedLicense = response.Result;
      dispatch({
        type: 'BEGIN_DEACTIVATION_SUCCESS',
      });
      dispatch({
        type: 'FETCH_LICENSE_SUCCESS',
        licenseSerial: updatedLicense.Serial,
        license: updatedLicense,
      });
      dispatch({
        type: 'CLOSE_MODAL',
      });
    });
}
